export const useCalculateFitInput = () => {
    const AVERAGE_TEXT = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"

    const calculateInputMaxChars = (inputElement: HTMLInputElement) => {
        if (!inputElement) return

        const style = window.getComputedStyle(inputElement)
        const font = `${style.fontSize} ${style.fontFamily}`
        const canvas = document.createElement("canvas")
        const context = canvas.getContext("2d")
        context.font = font
        const avgCharWidth = context.measureText(AVERAGE_TEXT).width / AVERAGE_TEXT.length

        const paddingLeft = parseFloat(style.paddingLeft) || 0
        const paddingRight = parseFloat(style.paddingRight) || 0

        const usableWidth = inputElement.clientWidth - paddingLeft - paddingRight

        return Math.ceil(usableWidth / avgCharWidth)
    }

    const calculateTextareaMaxChars = (textareaElement: HTMLTextAreaElement) => {
        if (!textareaElement) return

        const style = window.getComputedStyle(textareaElement)
        const font = `${style.fontSize} ${style.fontFamily}`
        const canvas = document.createElement("canvas")
        const context = canvas.getContext("2d")
        context.font = font
        const avgCharWidth = context.measureText(AVERAGE_TEXT).width / AVERAGE_TEXT.length
        const lineHeight = parseFloat(style.lineHeight) || parseFloat(style.fontSize) * 1.2

        const paddingLeft = parseFloat(style.paddingLeft) || 0
        const paddingRight = parseFloat(style.paddingRight) || 0
        const paddingTop = parseFloat(style.paddingTop) || 0
        const paddingBottom = parseFloat(style.paddingBottom) || 0

        const usableWidth = textareaElement.clientWidth - paddingLeft - paddingRight
        const usableHeight = textareaElement.clientHeight - paddingTop - paddingBottom

        const charsPerLine = Math.floor(usableWidth / avgCharWidth)
        const lines = Math.floor(usableHeight / lineHeight)

        return charsPerLine * lines
    }

    return {calculateInputMaxChars, calculateTextareaMaxChars}
}
